export const Logo = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="24" cy="32" r="13" fill="none" stroke="currentColor" strokeWidth="5" />
    <circle cx="24" cy="32" r="4" fill="#FF2A2A" />
    <path d="M37 32h19M48 32v8M54 32v6" stroke="currentColor" strokeWidth="5" strokeLinecap="square" fill="none" />
    <path d="M14 44l20-24" stroke="#FF2A2A" strokeWidth="3" />
  </svg>
);

export const Wordmark = () => (
  <span className="flex items-center gap-2.5">
    <Logo className="h-9 w-9 text-zinc-100" />
    <span className="font-display text-2xl font-black uppercase leading-none tracking-tight">
      RB<span className="text-[var(--red)]">/</span>TUN
    </span>
  </span>
);
